import { Modal } from '@mui/material';
import { Fragment, memo, useCallback, useEffect, useMemo } from 'react';
import { AeEditor } from '@diana/core';
import { useFlowBuilder2PageStore } from '../Store/useFlowBuilder2PageStore';
import { UpdateAssetValue } from '../ActivityEditors/UpdateAssetValue/UpdateAssetValue';
import { AiPendingChangesModalContent } from '../Components/EditAssistant/AiPendingChangesModalContent';
import { FlowBuilderModalContentTypeEnum } from '../Store/FlowBuilder2PageStore.types';

export const FlowBuilder2PageModal = memo(() => {
  const activeModal = useFlowBuilder2PageStore((s) => s.activeModal);
  const setActiveModal = useFlowBuilder2PageStore((s) => s.setActiveModal);

  const onCloseModal = useCallback(() => {
    setActiveModal(null);
  }, [setActiveModal]);

  const content = useMemo(() => {
    if (activeModal) {
      switch (activeModal.name) {
        case FlowBuilderModalContentTypeEnum.UpdateAssetValue:
          return <UpdateAssetValue ctx={activeModal.context} onClose={onCloseModal} />;

        case FlowBuilderModalContentTypeEnum.AdvancedEditor:
          return <AeEditor setModalClose={onCloseModal} />;

        case FlowBuilderModalContentTypeEnum.AiAcceptReject:
          return <AiPendingChangesModalContent />;
      }
    }

    return <Fragment />;
  }, [activeModal, onCloseModal]);

  useEffect(() => {
    return () => {
      setActiveModal(null);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Modal
      open={!!activeModal}
      onClose={(_, reason) => {
        if (reason === 'escapeKeyDown') return;
        setActiveModal(null);
      }}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      {content}
    </Modal>
  );
});
